export default "__VITE_ASSET__AKjqEh3S__"